<div class="qt-keyboard-wrapper" [class.debug]="isDebug$ | async">
  <nav class="qt-keyboard-layout">
    @for (row of layout.keys; track row) {
      <div class="qt-keyboard-row">
        @for (key of row; track key) {
          @if (getModifiedKey(key)) {
            <qt-keyboard-key
              class="qt-keyboard-col"
              [key]="getModifiedKey(key)"
              [active]="isActive(key)"
              [input]="inputInstance | async"
              [control]="$any(control)"
              (enterClick)="onEnterClick()"
              (capsClick)="onCapsClick()"
              (altClick)="onAltClick()"
              (shiftClick)="onShiftClick()"></qt-keyboard-key>
          }
        }
      </div>
    }
  </nav>
</div>
